module.exports = __webpack_public_path__ + "img/08_WebFlow_11-3.67f58327.svg";